import { useContext } from 'react';

import { TimeseriesToolbarContext } from '../context/TimeseriesToolbar.context.js';

export const useChartToolbar = () => useContext(TimeseriesToolbarContext);
